import { scrollToChatBottom } from "./scrollToChatBottom";

export function initMessageLoader(
  messageElement,
  chatForm = null,
  category = "text",
  loaderText = null
) {
  const chatRoot = chatForm
    ? chatForm.hasClass("g-chatform")
      ? chatForm
      : chatForm.closest(".g-chatform")
    : messageElement.closest(".g-chatform");

  const messageRole = messageElement.attr("data-role");

  if (!chatRoot.length) return;
  const chatId = chatRoot.attr("id");
  let loader = messageElement.find(".g-chatform-message-content-loader");
  if (!loader.length) {
    const loaderHtml = window.growtype_chat?.[chatId]?.message_content_loader;
    loader = jQuery(loaderHtml).appendTo(messageElement);
  }

  // Ensure only one loader is visible in this chat at any time.
  // Proactively hide or remove any other active loader bubbles in the same chat content container.
  const contentWrapper = chatRoot.find(".g-chatform-content");
  if (contentWrapper.length) {
    // Find all other user messages with loaders that are not this current element
    contentWrapper
      .find('.g-chatform-message[data-role="user"]')
      .not(messageElement)
      .each(function () {
        const otherMessage = jQuery(this);
        // Hide the text loader element inside those other bubbles, but leave media generation loaders alone
        otherMessage.find(".g-chatform-message-content-loader").hide();
        // Also ensure the overall bubble is hidden if it was just a placeholder
        if (otherMessage.hasClass("is-pending-response")) {
          otherMessage.hide();
        }
      });
  }

  // Apply the pending state class to ensure correct avatar-showing and background-hiding styles
  messageElement.addClass("is-pending-response");

  // Show loader dots
  loader.addClass("style-dots").show();

  // Set character name in loader if available
  const chatConfig = window.growtype_chat?.[chatId] || {};
  const botProfile = chatConfig.bot_profile || null;
  const responseCharacter = botProfile?.response_character || null;
  const characters = chatConfig.characters || [];
  const attachedCharacter = characters[0] || null;
  const attachedCharacterName = chatConfig?.characters?.[0]?.name || "";
  let botName =
    responseCharacter?.name ||
    (botProfile && botProfile.name ? botProfile.name : "") ||
    attachedCharacterName ||
    "";
  let activeCharacter = responseCharacter || attachedCharacter;

  if (!botName) {
    botName = chatRoot.find(".g-chatform-header-users-single p").text().trim();
  }

  // The backend-selected responder is authoritative. Only a chat with no
  // responder identity at all may use the legacy random fallback.
  if (!botName && characters.length > 0) {
    const randomChar =
      characters[Math.floor(Math.random() * characters.length)];
    botName = randomChar.name;
    activeCharacter = randomChar;
    messageElement.data("active-character", randomChar);
  }

  if (activeCharacter) {
    messageElement.data("active-character", activeCharacter);
  } else {
    messageElement.removeData("active-character");
  }

  if (messageRole === "user") {
    loader.find(".loader-dots").hide();
  }

  if (messageRole === "user" && botName) {
    // Use explicit loaderText if provided, otherwise fall back to data attribute, chat config, or auto-generated text
    const customText =
      loaderText ||
      messageElement.attr("data-loader-text") ||
      (window.growtype_chat?.[chatId]?.loader_text);
    const firstName = botName.split(" ")[0];
    const verb = ["image", "video", "audio"].includes(category)
      ? "generating"
      : "typing";
    const displayText = customText || `${firstName} is ${verb}...`;
    const loaderTextElement = loader.find(".loader-text");
    if (loaderTextElement.length === 0) {
      loader.append(
        `<div class="loader-text">${displayText}</div>`
      );
    } else {
      // Pending templates are reused, so never leave the prior character name.
      loaderTextElement.text(displayText);
    }
  }

  if (messageRole === "user") {
    // Set avatar image
    let avatarImg = chatRoot
      .find(".g-chatform-header-users-single-img")
      .first()
      .css("background-image");

    if ((!avatarImg || avatarImg === "none") && activeCharacter?.image) {
      avatarImg = `url("${activeCharacter.image}")`;
    }

    if (avatarImg && avatarImg !== "none") {
      let avatarContainer = messageElement.find(".avatar-img");
      if (!avatarContainer.length) {
        avatarContainer = jQuery('<div class="avatar-img"></div>').prependTo(
          loader
        );
      }
      avatarContainer.css("background-image", avatarImg);
    }
  }

  // Scroll to bottom so the loader bubble is visible immediately
  scrollToChatBottom(100, true);
}
